module.exports = __webpack_public_path__ + "img/face-laugh-wink.608054bd.svg";